import { getTypedStepValues } from "features/contracting/helpers/contractingFormHelper";
import ContractingStepSummaryProps from "features/contracting/models/ContractingStepSummaryProps";
import PaymentMethodStep from "features/contracting/models/steps/paymentMethod/PaymentMethodStep";
import { isBankAccountPaymentMethod, isSipoPaymentMethod } from "features/contracting/sections/contractingForms/paymentMethodForm/paymentMethodFormHelper";
import PageCard from "features/shared/components/card/PageCard";
import CheckValueInfoItem from "features/shared/components/infoItem/CheckValueInfoItem";
import RenderWrapper from "features/shared/components/renderWrapper/RenderWrapper";
import { formatNumber, formatPrice } from "features/shared/helpers/Formatters";
import { useTranslationWithPrefix } from "features/shared/hooks/useTranslationWithPrefix";
import React from "react";
import { useTranslation } from "react-i18next";

const PaymentMethodSummary = ({
  contracting,
  step,
}: ContractingStepSummaryProps) => {
  // translations
  const tPaymentMethodType = useTranslation("contracting\\contracting").t;
  const tLabels = useTranslationWithPrefix("contracting\\contracting", "paymentMethodSummary");

  // private props
  const values = getTypedStepValues<PaymentMethodStep>(
    contracting,
    step.component
  );

  // helpers
  const tPaymentMethod = (value: string) => {
    return tPaymentMethodType(`paymentMethodTypeSubForm.paymentType.${value}`);
  };

  const formatDepositsAmount = (value: number) => {
    return formatPrice(value, values.currency!);
  };

  // render
  return (
    <>
      <PageCard
        title={tLabels("cardTitle")}
        bodyClassName="px-4 py-3"
      >
        <CheckValueInfoItem
          title={tLabels("depositPaymentTypeCode")}
          value={values.depositPaymentTypeCode}
          formatValue={tPaymentMethod}
        />
        <RenderWrapper isVisible={() => isSipoPaymentMethod(values)}>
          <CheckValueInfoItem
            title={tLabels("invoicePaymentTypeCode")}
            value={values.invoicePaymentTypeCode}
            formatValue={tPaymentMethod}
          />
        </RenderWrapper>
      </PageCard>

      <RenderWrapper isVisible={() => isSipoPaymentMethod(values)}>
        <PageCard title={tLabels("sipoCardTitle")} bodyClassName="px-4 px-3">
          <CheckValueInfoItem title={tLabels("sipoNumber")} value={values.sipoNumber} />
        </PageCard>
      </RenderWrapper>

      <RenderWrapper isVisible={() => isBankAccountPaymentMethod(values)}>
        <PageCard title={tLabels("bankAccountCardTitle")} bodyClassName="px-4 px-3">
          <CheckValueInfoItem title={tLabels("preAccountNumber")} value={values.preAccountNumber} />
          <CheckValueInfoItem title={tLabels("accountNumber")} value={values.accountNumber} />
          <CheckValueInfoItem title={tLabels("bankCode")} value={values.bankCode} />
        </PageCard>
      </RenderWrapper>

      <PageCard
        title={tLabels("depositsAmountCardTitle")}
        bodyClassName="px-4 py-3"
      >
        <CheckValueInfoItem
          title={tLabels("depositsAmount")}
          value={values.depositsAmount}
          formatValue={formatDepositsAmount}
        />
      </PageCard>
    </>
  );
};

export default PaymentMethodSummary;
